import Knock from '@knocklabs/client'

export const knock_client = new Knock(import.meta.env.VITE_KNOCK_API_KEY)

